import React from 'react';

import { Skeleton } from '@mui/material';

export const LoadingSkeleton = () => {
  return <Skeleton variant="rectangular" height="80%" />;
};
